export function renderTicker(containerEl, text) {
  if (!containerEl) return;

  const inner = document.createElement('span');
  inner.className = 'remote-ticker-inner';
  inner.textContent = text;

  containerEl.textContent = '';
  containerEl.appendChild(inner);

  requestAnimationFrame(() => {
    const viewWidth = containerEl.clientWidth;
    const textWidth = inner.scrollWidth;
    if (textWidth > viewWidth + 1) {
      const durationSeconds = Math.max(4, textWidth / 30);
      inner.style.animationDuration = `${durationSeconds}s`;
      inner.classList.add('animating');
    } else {
      inner.classList.remove('animating');
      inner.style.animationDuration = '';
    }
  });
}

